import { useEffect, useState } from "react";

type TocItem = { id: string; no: string; title: string };

export default function GuideToc({ items }: { items: TocItem[] }) {
  const [active, setActive] = useState(items[0]?.id ?? "");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-96px 0px -70% 0px", threshold: 0 },
    );
    items.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [items]);

  return (
    <nav aria-label="文章目录" className="lg:sticky lg:top-24">
      <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-foreground-500">
        <i className="ri-list-check-2 text-sm leading-none"></i>
        文章目录
      </p>
      <ol className="mt-4 space-y-1 border-l border-background-200">
        {items.map((item) => {
          const isActive = active === item.id;
          return (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={`-ml-px flex items-baseline gap-2.5 border-l-2 py-2 pl-4 text-sm transition-colors cursor-pointer ${
                  isActive
                    ? "border-primary-500 font-semibold text-primary-600"
                    : "border-transparent text-foreground-600 hover:border-background-400 hover:text-foreground-900"
                }`}
              >
                <span className="font-heading text-xs text-foreground-400">{item.no}</span>
                {item.title}
              </a>
            </li>
          );
        })}
      </ol>

      <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4">
        <p className="text-sm font-medium text-foreground-900">投稿遇到卡点？</p>
        <p className="mt-2 text-xs leading-relaxed text-foreground-600">
          带上你的线索直接提交，编辑会在回复里针对你的材料给出具体建议。
        </p>
        <a
          href="#guide-faq"
          className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 cursor-pointer"
        >
          查看常见问题
          <i className="ri-arrow-right-line text-sm leading-none"></i>
        </a>
      </div>
    </nav>
  );
}